module.exports = __webpack_public_path__ + "static/media/resume.3469f830.png";